var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.className == 'full' ? _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "line-layout-tit-wrap mb-20 mb-lg-40",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium line-layout-tit"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")])]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm._t("default")], 2)], 1) : _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "line-layout-tit-wrap mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('h5', {
    staticClass: "tit--sm font-weight-medium line-layout-tit"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")])]), _c('v-col', {
    staticClass: "line-layout-content pl-lg-40",
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }